import './panel-list.css';

const numberFormatter = new Intl.NumberFormat('nl-BE', {
  maximumFractionDigits: 2,
});

function getPropertyRecord(data) {
  if (data?.properties && typeof data.properties === 'object') {
    return data.properties;
  }

  return data && typeof data === 'object' ? data : {};
}

function formatLabel(label) {
  return label
    .replace(/(?:[_\s])bronsleutel6$/i, '')
    .replace(/(?:[_\s])combosleutel_bs6_vs1$/i, '')
    .replace(/_/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2');
}

function formatValue(value) {
  if (value === undefined || value === null || value === '') return '-';
  if (typeof value === 'number') return numberFormatter.format(value);
  if (typeof value === 'boolean') return value ? 'Ja' : 'Nee';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}

function getRecordDetails(record) {
  return Object.entries(record).filter(([key]) => {
    if (['Naam', 'naam', 'name', 'geometry', 'type', 'bbox'].includes(key)) {
      return false;
    }

    if (/(?:^|[_\s])bronsleutel\d*$/i.test(key)) {
      return /(?:^|[_\s])bronsleutel6$/i.test(key);
    }

    if (/(?:^|[_\s])combosleutel_bs\d+_vs\d+$/i.test(key)) {
      return /(?:^|[_\s])combosleutel_bs6_vs1$/i.test(key);
    }

    return true;
  });
}

function PanelList({ data, details }) {
  const propertyListDetails = details || getRecordDetails(getPropertyRecord(data));

  return (
    <dl className="panel-list">
      {propertyListDetails.map(([label, value]) => (
        <div className="panel-list__row" key={label}>
          <dt>{details ? label : formatLabel(label)}</dt>
          <dd>{details ? value : formatValue(value)}</dd>
        </div>
      ))}
    </dl>
  );
}

export { getPropertyRecord };
export default PanelList;
